import machineDefaultImage from '../../../images/machineImageEmpty.svg';
import { typedDocumentsImageUrl } from '../../../utils/imageProxy';
import { Box, Typography, Grid } from '@mui/material';
import '../../../css/machines/localisationEtStatut.css';

const EquipmentBox = ({ image, title }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '3px', mb: 2 }}>
            <img src={image} alt="icon" style={{ width: '45px', height: '45px', borderRadius: '2px', objectFit: 'cover' }} loading='lazy' decoding='async' />
            <Typography className='modeEtConseigne_text_response'>{title}</Typography>
        </Box>
    );
};

const PublicMachineEquipment = ({ equipment_machine }) => {

    if (!equipment_machine?.length) {
        return null;
    }

    return (
        <Box className='localisationEtStatut_box'>
            <Box className='localisation_edit_box'>
                <Typography className='localisationEtStatut_title'>Équipements</Typography>
            </Box>
            <Box className='localisationEtStatut_icon_title_response_box'>
                <Grid container spacing={4}>
                    {equipment_machine.map((e) => {
                        const img = typedDocumentsImageUrl(e?.equipment?.equipment_document, { size: 'picto', fallback: machineDefaultImage });
                        return (
                            <Grid key={e?.id} item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <EquipmentBox
                                    image={img}
                                    title={e?.equipment?.name}
                                />
                            </Grid>
                        );
                    })}
                </Grid>
            </Box>
        </Box>
    );
};

export default PublicMachineEquipment;
